import styled from 'styled-components'

export const DragAndDropContainer = styled.div`
  width: 100%;
  height: 100%;
`

export const ImageContainer = styled.div<{
  $image?: string
  $onEdition: boolean
}>`
  border-radius: 16px;
  border: ${(props) => (props.$image ? 'none' : '1px dashed #d1d5db')};
  min-height: 200px;
  padding: 18px;
  text-align: center;
  color: #6b7280;
  background-color: ${(props) => (props.$onEdition ? ' #f9fafb' : ' #F6F6F6')};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: ${(props) => (props.$onEdition ? 'pointer' : 'inherit')};
  width: 100%;
  height: 100%;
  position: relative;
`

export const Image = styled.div<{ $image?: string; $onEdition: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  background-color: ${(props) => (props.$image ? '#F6F6F6' : undefined)};
  background-image: ${(props) => `url(${props.$image})`};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .overlay {
    width: 100%;
    height: 100%;
    background: #313131a3;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    cursor: pointer;

    p {
      font-size: 16px;
      line-height: 15px;
      color: #fff;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      svg {
        font-size: 24px;
      }
    }

    &:hover {
      opacity: 1;
    }
  }
`
export const EditImageModal = styled.div`
  height: auto;
  width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
    height: auto;
  }
`
